import {Injectable} from '@angular/core';

export const CLASS_FOCUS = 'slide-focus';
export const CLASS_BLUR = 'slide-blur';

@Injectable()
export class SlideContext {
  public foo;
}



// WEBPACK FOOTER //
// ./src/app/classes.ts